const timeFilter = require('../../../../utils/timestamp-util').timestampToDateFilter;

const DATA_TYPE = {
    Int8: "Int8",
    UInt8: "UInt8",
    Int16: "Int16LE",
    UInt16: "UInt16LE",
    Int32LE: "Int32LE",
    UInt32LE: "UInt32LE",
};

function fixFloat(float, fractionDigits = 1) {
    return parseFloat(float.toFixed(fractionDigits));
}

const IPSO_PARSER = {
    0: parseSimpleData("digital_input", DATA_TYPE.UInt8),
    1: parseSimpleData("digital_output", DATA_TYPE.UInt8),
    2: parseAIData,
    3: parseSimpleData("analog_output", DATA_TYPE.Int16, value => fixFloat(value * 0.01)),
    101: parseSimpleData("illumiance_sensor", DATA_TYPE.UInt16),
    102: parseSimpleData("presence_sensor", DATA_TYPE.UInt8),
    103: parseSimpleData("temperature_sensor", DATA_TYPE.Int16, value => fixFloat(value * 0.1)),
    104: parseSimpleData("humidity_sensor", DATA_TYPE.UInt8, value => fixFloat(value * 0.5)),
    106: parseSimpleData("actuation", DATA_TYPE.UInt16),
    115: parseSimpleData("barometer_pressure", DATA_TYPE.UInt16, value => fixFloat(value * 0.1)),
    116: parseSimpleData("voltage", DATA_TYPE.UInt16, value => fixFloat(value * 0.01)),
    117: parseSimpleData("current", DATA_TYPE.UInt8),
    119: parseSimpleData("depth", DATA_TYPE.UInt16),
    123: parseSimpleData("pressure", DATA_TYPE.UInt16),
    124: parseSimpleData("loudness", DATA_TYPE.UInt16, value => fixFloat(value * 0.1)),
    125: parseSimpleData("concentration", DATA_TYPE.UInt16),
    128: parseSimpleData("power", DATA_TYPE.UInt16, value => fixFloat(value * 0.01)),
    130: parseSimpleData("distance", DATA_TYPE.UInt16, value => fixFloat(value * 0.01)),
    146: parseSimpleData("par", DATA_TYPE.UInt16, value => fixFloat(value * 0.1)),
    200: parseSimpleData("counter", DATA_TYPE.UInt32LE),
};

// todo 最好合并
const IPSO_TYPE = {
    0: "digital_input",
    1: "digital_output",
    2: "analog_input",
    3: "analog_output",
    101: "illumiance_sensor",
    102: "presence_sensor",
    103: "temperature_sensor",
    104: "humidity_sensor",
    106: "actuation",
    115: "barometer_pressure",
    116: "voltage",
    117: "current",
    119: "depth",
    123: "pressure",
    124: "loudness",
    125: "concentration",
    128: "power",
    130: "distance",
    146: "par",
    200: "counter",
};

const URSA_TYPE = {
    1: "version",
    2: "interval",
    3: "period",
    4: "response",
    5: "LoRa_chan_mask",
    6: "alarm_config",
    7: "debug_level",
    8: "sn",
    9: "hardware",
    10: "firmware",
    11: "power_on",
    12: "power_off",
    13: "alarm_report",
    14: "channels",
    15: "class",
    16: "reboot",
    17: "timestamp",
    18: "text",
    19: "intelligent_report",
    20: "conversion",
    21: "collect_failed",
    22: "sn",
};

function parse(reader) {
    let i = 1;
    while (reader.hasMore()) {
        const channel = reader.readUInt8(`${i}.channel`);
        const type = reader.readUInt8(`${i}.type`, type => channel !== 255 ? IPSO_TYPE[type] : URSA_TYPE[type]);
        const parser = getReadParser(channel, type);
        if (parser) {
            parser.parse(reader, i);
            i++;
        }
    }
}

function getReadParser(channel, type) {
    if (channel === 254 || channel === 255) {
        return {parse: URSA_PARSER[type]};
    } else {
        return {parse: IPSO_PARSER[type]};
    }
}

function parseSimpleData(property, dataType, converter = value => value) {
    return (reader, index) => {
        reader[`read${dataType}`](`${index}.data`, converter);
    };
}

function skip(length) {
    return reader => {
        reader.moveOffset(length);
    };
}

function parseAIData(reader, index) {
    const converter = value => value * 0.01;
    reader.readInt16LE(`${index}.data.ccy`, converter);
    reader.readInt16LE(`${index}.data.min`, converter);
    reader.readInt16LE(`${index}.data.max`, converter);
    reader.readInt16LE(`${index}.data.avg`, converter);
}

const parseSn = (length) => (reader, index) => {
    reader.readHexString(length, `${index}.data`);
};

function parseLoRaChanMask(reader, index) {
    reader.readUInt8(`${index}.data.id`);
    reader.readUInt16LE(`${index}.data.mask`);
}

function parseText(reader, index) {
    const length = reader.readUInt8(`${index}.data.length`);
    reader.readString(length, `${index}.data.text`);
}

function parseConversion(reader, index) {
    const value = reader.readUInt8(`${index}.data.index`);
    reader.result.set(`${index}.data.index`, (value & 240) >>> 4);
    reader.result.set(`${index}.data.type`, (value & 15) === 0 ? "mA" : "V");
}

const ALARM_MODE = ["DISABLE", "BELOW", "ABOVE", "WITHIN", "BELOW_OR_ABOVE"];
function parseAlarmConfig(reader, index) {
    const idAndMode = reader.readUInt8(`${index}.data.rule_id`, idAndMode => (idAndMode & 56) >>> 3);
    const mode = ALARM_MODE[idAndMode & 7];
    reader.result.set(`${index}.data.mode`, mode);
    reader.readInt16LE(`${index}.data.min`, value => value / 10);
    reader.readInt16LE(`${index}.data.max`, value => value / 10);
    reader.readInt16LE(`${index}.data.lock_time`);
    reader.readInt16LE(`${index}.data.continue_time`);
}

function parseAlarm(reader, index) {
    const MODE = ["DISABLE", "BELOW", "ABOVE", "WITHIN", "BELOW_OR_ABOVE"];
    const idAndMode = reader.readUInt8(`${index}.data.rule_id`, idAndMode => (idAndMode & 56) >>> 3);
    const mode = MODE[idAndMode & 7];
    reader.result.set(`${index}.data.mode`, mode);
    reader.readInt16LE(`${index}.data.min`, value => value / 10);
    reader.readInt16LE(`${index}.data.max`, value => value / 10);
    reader.readInt16LE(`${index}.data.current`, value => value / 10);
}

function parseVersion(property) {
    return (reader, index) => {
        const mainVer = reader.readUInt8(`${index}.data`);
        const mainVerHex = reader.result.get(`${index}.data`, 1);
        const subVer = reader.readUInt8(`${index}.data`);
        const subVerHex = reader.result.get(`${index}.data`, 1);
        const realSubVer = subVer % 16 === 0 && property === "hardware" ? Math.floor(subVer / 16) : subVer % 16 + Math.floor(subVer / 16) * 10;
        const realMainVer = mainVer % 16 + Math.floor(mainVer / 16) * 10;
        reader.setAllToResult(`${index}.data`, [`v${realMainVer}.${realSubVer}`, mainVerHex + subVerHex]);
    };
}

const CHANNEL_TYPE = ["REG_COIL", "REG_DISCRETE", "REG_INPUT", "REG_HOLD_INT16", "REG_HOLD_INT32",
    "REG_HOLD_FLOAT", "REG_INPUT_INT32", "REG_INPUT_FLOAT",
    "REG_INPUT_INT32_AB", "REG_INPUT_INT32_CD", "REG_HOLD_INT32_AB", "REG_HOLD_INT32_CD"];
function parseChannels(reader, index) {
    reader.readUInt8(`${index}.data.channel_id`);
    const type = reader.readUInt8(`${index}.data.data_type`, type => CHANNEL_TYPE[type & 7]);
    const dataType = CHANNEL_TYPE[type & 7];
    const dataLength = type >> 3;
    reader.result.set(`${index}.data.data_length`, dataLength);
    switch (dataType) {
        case "REG_COIL":
        case "REG_DISCRETE":
            reader.readUInt8(`${index}.data.value`);
            break;
        case "REG_INPUT":
        case "REG_HOLD_INT16":
        case "REG_INPUT_INT32_AB":
        case "REG_INPUT_INT32_CD":
        case "REG_HOLD_INT32_AB":
        case "REG_HOLD_INT32_CD":
            reader.readUInt16LE(`${index}.data.value`);
            break;
        case "REG_HOLD_INT32":
        case "REG_INPUT_INT32":
            reader.readUInt32LE(`${index}.data.value`);
            break;
        case "REG_HOLD_FLOAT":
        case "REG_INPUT_FLOAT":
            reader.readFloatLE(`${index}.data.value`);
            break;
    }
}

const URSA_PARSER = {
    1: parseSimpleData("version", DATA_TYPE.UInt8, value => value.toString()),
    2: parseSimpleData("interval", DATA_TYPE.UInt16),
    3: parseSimpleData("period", DATA_TYPE.UInt16),
    4: skip(1, "response"), // response
    5: parseLoRaChanMask,
    6: parseAlarmConfig, // alarmConfig
    7: skip(1, "debug_level"), // debugLevel
    8: parseSn(6), // sn
    9: parseVersion("hardware"),
    10: parseVersion("firmware"),
    11: parseSimpleData("power_on", DATA_TYPE.UInt8, value => value > 0),
    12: parseSimpleData("power_off", DATA_TYPE.UInt8, value => value > 0),
    13: parseAlarm,
    14: parseChannels,
    15: parseSimpleData("class", DATA_TYPE.UInt8, value => ["ClassA","ClassB","ClassC"][value]),
    16: parseSimpleData("reboot", DATA_TYPE.UInt8),
    17: parseSimpleData("timestamp", DATA_TYPE.UInt32LE, timeFilter),
    18: parseText,
    19: parseSimpleData("intelligent_report", DATA_TYPE.UInt8),
    20: parseConversion,
    21: parseSimpleData("collect_failed", DATA_TYPE.UInt8),
    22: parseSn(8),
};

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/ipso/v1/11.js